var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBorde(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1370,
    height: 427,
    viewBox: "0 0 1370 427",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1347.38 425H22.64C22.6453 423.758 22.1153 422.527 21.0804 421.378C20.0455 420.23 18.526 419.186 16.6088 418.307C14.6917 417.427 12.4146 416.73 9.90784 416.254C7.40107 415.778 4.71385 415.533 2 415.533V11.4488C7.47407 11.4488 12.7239 10.4533 16.5947 8.68133C20.4654 6.90933 22.64 4.50599 22.64 2H1347.38C1347.38 4.5044 1349.55 6.90636 1353.42 8.6781C1357.28 10.4498 1362.53 11.4464 1368 11.4488V415.533C1365.29 415.534 1362.6 415.78 1360.1 416.257C1357.59 416.733 1355.32 417.431 1353.4 418.31C1351.49 419.189 1349.97 420.233 1348.94 421.381C1347.9 422.528 1347.37 423.758 1347.38 425Z",
    stroke: "url(#paint0_linear_258_24)",
    strokeWidth: 4,
    strokeMiterlimit: 10
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_258_24",
    x1: 120.83,
    y1: 471.763,
    x2: 511.834,
    y2: -382.336,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#DFCB80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#6B6342"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4D494"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBorde);
export default __webpack_public_path__ + "static/media/borde.c2b93448a703e1903ec422e82fcdc04c.svg";
export { ForwardRef as ReactComponent };